import PropTypes from 'prop-types';
import { statusConfig } from '../lib/portfolioConstants';

const RagBadge = ({ rag, large }) => {
  const sc = statusConfig[rag];
  if (!sc) return <p className={large ? 'text-sm text-slate-400' : 'text-xs text-slate-400'}>—</p>;
  const Icon = sc.icon;
  return large ? (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-bold ${sc.bgLight} ${sc.textColor}`}>
      <Icon className="w-4 h-4" />{sc.label}
    </span>
  ) : (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${sc.bgLight} ${sc.textColor}`}>
      <Icon className="w-3 h-3" />{sc.label}
    </span>
  );
};

RagBadge.propTypes = {
  rag: PropTypes.string,
  large: PropTypes.bool,
};

export default RagBadge;
